import React from 'react';
import { Link } from 'react-router-dom';
import {
  Page,
  Button,
  Card,
  Chip,
} from '../../components';
import { useDeviceId } from '../../hooks';

export const LandingPage: React.FC = () => {
  const deviceId = useDeviceId();

  return (
    <Page
      appBar={{ title: 'Car-IA', transparent: true }}
      className="pb-24"
    >
      <div className="flex flex-col gap-6">
        {/* Hero Section */}
        <div className="text-center py-8">
          <div className="mx-auto mb-6 w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center">
            <span className="material-symbols-outlined text-primary text-4xl">directions_car</span>
          </div>
          <h1 className="font-display-lg-mobile text-on-surface mb-2">
            Vistoria Inteligente
          </h1>
          <p className="font-body-md text-on-surface-variant max-w-md mx-auto">
            Faça a vistoria do seu veículo pelo celular. Fotos guiadas, análise por IA e laudo técnico em minutos.
          </p>
        </div>

        {/* Main Actions */}
        <div className="space-y-4">
          <Link to="/inspecao/nova" replace>
            <Button
              variant="primary"
              fullWidth
              size="default"
              leftIcon={<span className="material-symbols-outlined">add_circle</span>}
              className="h-14 text-lg"
            >
              Nova Vistoria
            </Button>
          </Link>

          <Link to="/inspecao/historico">
            <Button
              variant="outline"
              fullWidth
              leftIcon={<span className="material-symbols-outlined">history</span>}
              className="h-14"
            >
              Minhas Vistorias
            </Button>
          </Link>
        </div>

        {/* Benefits */}
        <div className="grid grid-cols-2 gap-4 mt-8">
          <Card variant="elevated" className="text-center py-4">
            <div className="mb-2 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto">
              <span className="material-symbols-outlined text-primary text-2xl">camera_alt</span>
            </div>
            <p className="font-label-md">8 Fotos Guiadas</p>
            <p className="font-body-sm text-on-surface-variant mt-1">Capture todos os ângulos necessários</p>
          </Card>
          <Card variant="elevated" className="text-center py-4">
            <div className="mb-2 w-12 h-12 rounded-xl bg-success-bg/50 flex items-center justify-center mx-auto">
              <span className="material-symbols-outlined text-success text-2xl">psychology</span>
            </div>
            <p className="font-label-md">Análise por IA</p>
            <p className="font-body-sm text-on-surface-variant mt-1">Detecção automática de avarias</p>
          </Card>
          <Card variant="elevated" className="text-center py-4">
            <div className="mb-2 w-12 h-12 rounded-xl bg-warning-bg/50 flex items-center justify-center mx-auto">
              <span className="material-symbols-outlined text-warning text-2xl">description</span>
            </div>
            <p className="font-label-md">Laudo Técnico</p>
            <p className="font-body-sm text-on-surface-variant mt-1">Relatório completo com nota A/B/C</p>
          </Card>
          <Card variant="elevated" className="text-center py-4">
            <div className="mb-2 w-12 h-12 rounded-xl bg-secondary-container/50 flex items-center justify-center mx-auto">
              <span className="material-symbols-outlined text-secondary text-2xl">shield</span>
            </div>
            <p className="font-label-md">Seguro e Rápido</p>
            <p className="font-body-sm text-on-surface-variant mt-1">Processamento em minutos</p>
          </Card>
        </div>

        {/* Info chips */}
        <div className="flex flex-wrap justify-center gap-2 mt-6">
          <Chip variant="info" icon={<span className="material-symbols-outlined text-sm">check_circle</span>}>
            Sem cadastro
          </Chip>
          <Chip variant="info" icon={<span className="material-symbols-outlined text-sm">check_circle</span>}>
            Gratuito
          </Chip>
          <Chip variant="info" icon={<span className="material-symbols-outlined text-sm">check_circle</span>}>
            Funciona offline
          </Chip>
        </div>

        {/* Debug info (development only) */}
        {import.meta.env.DEV && (
          <Card variant="outlined" padding="sm" className="mt-8">
            <p className="font-label-sm text-on-surface-variant">Device ID: <code className="font-body-sm tabular-nums">{deviceId}</code></p>
          </Card>
        )}
      </div>
    </Page>
  );
};